import { withoutTime } from '@bingads-webui-universal/primitive-utilities';
import _ from 'underscore';
import getStateDateRange from './util/get-state-date-range';
import getStateComparedDateRange from './util/get-state-compared-date-range';

export default function convertSelectionDateRangeToState({
  Selection: {
    DateRange,
    ComparisonDateRange,
  },
  i18n,
}) {
  const primaryRange = getStateDateRange({
    today: withoutTime(new Date()),
    i18n,
    DateRange,
  });

  return _.extend({}, primaryRange, {
    compared: getStateComparedDateRange({
      today: withoutTime(new Date()),
      i18n,
      primaryRange,
      ComparisonDateRange,
    }),
  });
}
